"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var actionInfo = {
  supportsUndoRedo: true,
  refresh: {
    render: true
  }
};

var ConditionalFormattingAPISpec = /*#__PURE__*/function () {
  function ConditionalFormattingAPISpec() {}

  var _proto = ConditionalFormattingAPISpec.prototype;

  _proto.getAPISpec = function getAPISpec() {
    var _this = this;

    if (!this.apiSpec) {
      this.apiSpec = {
        name: 'conditional formatting API',
        events: {
          actions: {
            setScale: {
              eventName: 'scale',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], _this.getScale(args[0])]
                }];
              }
            },
            setPaletteId: {
              eventName: 'paletteId',
              info: Object.assign({}, actionInfo, {
                refresh: {
                  render: true,
                  propertiesPane: true
                }
              }),
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], _this.getPaletteId(args[0])]
                }];
              }
            },
            setBackgroundOpacity: {
              eventName: 'backgroundOpacity',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], _this.getBackgroundOpacity(args[0])]
                }];
              }
            },
            setRangeOperator: {
              eventName: 'rangeOperator',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRangeOperator(args[0], args[1])]
                }];
              }
            },
            setRuleStartConditionType: {
              eventName: 'startConditionType',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleStartConditionType(args[0], args[1])]
                }];
              }
            },
            setRuleStartConditionValue: {
              eventName: 'startConditionValue',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleStartConditionValue(args[0], args[1])]
                }];
              }
            },
            setRuleEndConditionType: {
              eventName: 'endConditionType',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleEndConditionType(args[0], args[1])]
                }];
              }
            },
            setRuleEndConditionValue: {
              eventName: 'endConditionValue',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleEndConditionValue(args[0], args[1])]
                }];
              }
            },
            setRuleStyleTextColor: {
              eventName: 'ruleStyleTextColor',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleStyleTextColor(args[0], args[1])]
                }];
              }
            },
            setRuleStyleFillColor: {
              eventName: 'ruleStyleFillColor',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleStyleFillColor(args[0], args[1])]
                }];
              }
            },
            setRuleStyleShape: {
              eventName: 'ruleStyleShape',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  params: [args[0], args[1], _this.getRuleStyleShape(args[0], args[1])]
                }];
              }
            },
            deleteRule: {
              eventName: 'deleteRule',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  name: 'addRule',
                  params: [args[0], args[1], _this.getRule(args[0], args[1])]
                }];
              }
            },
            addRule: {
              eventName: 'addRule',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  name: 'deleteRule',
                  params: [args[0], args[1], args[2]]
                }];
              }
            },
            moveRule: {
              eventName: 'moveRule',
              info: actionInfo,
              getUndoActions: function getUndoActions(args) {
                return [{
                  name: 'moveRule',
                  params: [args[0], args[2], args[1]]
                }];
              }
            },
            setSummaryFillColor: {
              eventName: 'summaryFillColor',
              info: actionInfo,
              getUndoActions: function getUndoActions() {
                return [{
                  name: 'setSummaryFillColor',
                  params: [_this.getSummaryFillColor()]
                }];
              }
            }
          }
        }
      };
    }

    return this.apiSpec;
  };

  return ConditionalFormattingAPISpec;
}();

exports.default = ConditionalFormattingAPISpec;
